import "./DocumentPreviewModal.scss";
import React, { useEffect } from "react";
import Button from "../button/button";

import IconButton from "../iconButton/iconButton"
import CloseIcon from "../../assets/images/closeCancel.svg";
import PrevIconIcon from "../../assets/images/rightArrow.svg";
import NextIconIcon from "../../assets/images/leftArrow.svg";
import DownloadIcon from "../../assets/images/download.svg";

export default function DocumentPreviewModal({ fileTitle, fileDescription, open, onClose, onPrev, onNext, hasPrev, hasNext, loading, fileUrl, mimeType, onDownload }) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" &&  hasNext && !loading) onNext();
      if (e.key === "ArrowRight" && hasPrev && !loading) onPrev();
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose, onPrev, onNext, hasPrev, hasNext, loading]);

  if (!open) return null;

  const canShowImage = mimeType?.startsWith("image/");
  const canShowPdf = mimeType === "application/pdf";

  return (
    <div className="modalBackdrop">
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <IconButton icon={CloseIcon} tooltip="بستن" onClick={onClose} className="closeIcon" />
          <IconButton icon={PrevIconIcon} tooltip="قبلی" onClick={onPrev} className="ss" />
          <div className="fileInformation">
            <div className="fileTitle">{fileTitle}</div>
            <div className="fileDescription">{fileDescription}</div>
          </div>
          <IconButton icon={NextIconIcon} tooltip="بعدی" onClick={onNext} className="ss" />
          <IconButton icon={DownloadIcon} tooltip="دانلود" onClick={onDownload} className="ss" />
          {/* <Button text="قبلی" icon={PrevIconIcon} onClick={onPrev} disabled={!hasPrev || loading} /> */}

          {/* <button onClick={onClose}>بستن</button> */}
          {/* <button onClick={onPrev} disabled={!hasPrev || loading}>قبلی</button> */}
          {/* <button onClick={onNext} disabled={!hasNext || loading}>بعدی</button> */}
          {/* <button onClick={onDownload} disabled={loading}>دانلود</button> */}
        </div>

        <div className="modalBody">
          {loading ? (
              <div style={{ height: "70vh", display: "grid", placeItems: "center" }}>
                در حال بارگذاری...
              </div>
          ) : ( 
            <>
              {canShowPdf && (
                <iframe title="pdf" src={fileUrl} style={{ width: "100%", height: "70vh", border: 0 }} />
              )}

              {canShowImage && (
                <img src={fileUrl} alt="preview" style={{ maxWidth: "100%", maxHeight: "70vh" }} />
              )}

              {!canShowPdf && !canShowImage && (
                <div>برای این نوع فایل پیش‌نمایش نداریم. می‌تونی دانلود کنی.</div>
              )}
            </>
          )}
          
        </div>
      </div>
    </div>
  );
}